import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCanoniMarketplace, getDatiAzienda } from '../services/api';
import { Container, Row, Col, Spinner, Alert, Table } from 'react-bootstrap';
import '../print.css';

function CanoniMarketplacePrint() {
  const navigate = useNavigate();
  const [canoni, setCanoni] = useState([]);
  const [datiAzienda, setDatiAzienda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [canoniResponse, aziendaResponse] = await Promise.all([
          getCanoniMarketplace(0, 10000), // Fetch all items
          getDatiAzienda()
        ]);
        setCanoni(canoniResponse.data.canoni);
        setDatiAzienda(aziendaResponse.data);
      } catch (err) {
        setError('Errore nel caricamento dei dati per la stampa.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, []);

  useEffect(() => {
    const handleAfterPrint = () => {
      setTimeout(() => {
        navigate('/canoni-marketplace');
      }, 100);
    };

    if (!loading && !error && canoni.length > 0 && datiAzienda) {
      window.addEventListener('afterprint', handleAfterPrint);
      window.print();
    }

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [loading, error, canoni, datiAzienda, navigate]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Preparazione stampa...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!datiAzienda) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Dati aziendali non trovati.</Alert>
      </Container>
    );
  }

  return (
    <div id="printable-area" className="A4-page">
      <header className="print-header">
        <Row className="align-items-center">
          <Col xs={4}>
            {datiAzienda.logo_url && (
              <img 
                src={`${process.env.REACT_APP_STATIC_FILES_BASE_URL}${datiAzienda.logo_url}`} 
                alt="Logo Azienda" 
                className="company-logo"
              />
            )}
          </Col>
          <Col xs={8} className="text-end">
            <h1>Lista Canoni Marketplace</h1>
            <p>Data di stampa: {new Date().toLocaleDateString()}</p>
          </Col>
        </Row>
      </header>

      <main className="print-main">
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>Denominazione</th>
              <th>Percentuale (%)</th>
              <th>Costo Fisso (€)</th>
            </tr>
          </thead>
          <tbody>
            {canoni.map((canone) => (
              <tr key={canone.id}>
                <td>{canone.id}</td>
                <td>{canone.denominazione}</td>
                <td className="text-end">{canone.percentuale.toFixed(2)}</td>
                <td className="text-end">{canone.costo_fisso.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </main>

      <footer className="print-footer">
        <p>{datiAzienda.denominazione} - {datiAzienda.indirizzo} - {datiAzienda.cap} {datiAzienda.citta} ({datiAzienda.provincia})</p>
        <p>P.IVA {datiAzienda.piva} - C.F. {datiAzienda.cf}</p>
        <p>Tel: {datiAzienda.tel} - Email: {datiAzienda.email}</p>
      </footer>
    </div>
  );
}

export default CanoniMarketplacePrint;
